module.exports = __webpack_public_path__ + "img/thumbnail-sub.eae06c42.png";